import axios from 'axios'
import React, { useEffect, useMemo, useState } from 'react'
import ReactModal from 'react-modal'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Modal from '../../components/Modal'
import swal from 'sweetalert'
import DetailsRequest from './DetailsRequest'
import HeaderTitle from '../../components/HeaderTitle'
import { Helmet } from 'react-helmet'
import { useForm } from 'react-hook-form'
import moment from 'moment'
import 'moment/locale/tr'
import { Tooltip } from 'react-tooltip'
import ExcelExport from "./../../components/ExcelExport/index"
import { canCreateDemand, canManageDemandWorkflow, hasAnyRole, isAdmin } from "../../utils/roleUtils"

moment.locale('tr')

/** Döküm / talep tarihi — tablo & Excel (Türkiye: GG.AA.YYYY) */
function formatCastingDateTr(value) {
    if (value == null || value === '') return '—'
    let m = moment(value)
    if (!m.isValid() && typeof value === 'string') {
        m = moment(value, ['DD.MM.YYYY', 'D.M.YYYY', 'YYYY-MM-DD', moment.ISO_8601], true)
    }
    return m.isValid() ? m.format('L') : String(value)
}

/** Talep saati — tablo & Excel (24 saat, SS:DD) */
function formatCastingTimeTr(value) {
    if (value == null || value === '') return '—'
    const s = typeof value === 'string' ? value.trim() : value
    let m = moment(s, ['HH:mm:ss', 'HH:mm', 'H:mm'], true)
    if (!m.isValid() && typeof s === 'string') {
        m = moment(s, moment.ISO_8601, true)
    }
    if (!m.isValid()) {
        m = moment(s)
    }
    return m.isValid() ? m.format('HH:mm') : String(value)
}

/** Döküm tarihi + saat — bugün → yarın → … ve aynı gün içinde saat sırası */
function castingScheduleMs(item) {
    if (!item) return Number.MAX_SAFE_INTEGER
    const d = item.concreteCastingDate
    const t = item.concreteCastingTime
    let m = moment(d, ['YYYY-MM-DD', 'D.M.YYYY', 'DD.MM.YYYY', moment.ISO_8601], true)
    if (!m.isValid()) m = moment(d)
    if (!m.isValid()) return Number.MAX_SAFE_INTEGER
    const tStr = t != null ? String(t).trim() : ''
    const tm = moment(tStr, ['HH:mm:ss', 'HH:mm', 'H:mm'], true)
    if (tm.isValid()) {
        m = m.clone().hour(tm.hour()).minute(tm.minute()).second(tm.second() || 0).millisecond(0)
    }
    return m.valueOf()
}

function compareDemandsByCastingSchedule(a, b) {
    return castingScheduleMs(a) - castingScheduleMs(b)
}

function Requests() {
    const { token, user, role } = useSelector((state) => state.auth)
    const [requests, setRequests] = useState([])
    const [statusList, setStatusList] = useState([])
    const [personalList, setPersonalList] = useState([])
    const [yapiDenetimList, setYapiDenetimList] = useState([])
    const [betonSantralList, setBetonSantralList] = useState([])
    const [vehicleList, setVehicleList] = useState([])
    const showRequestApproveButtonList = ["TALEP ALINDI", "GUNCELLEME ISTENDI", "YAPI DENETIM ONAYLADI", "BETON SANTRALI ONAYLADI"];

    const [excelData, setExcelData] = useState([])
    const [inPageIndex, setInPageIndex] = useState(0)

    const filterDefaults = useMemo(() => ({
        status: -1,
        castingDateGreater: moment().format('YYYY-MM-DD'),
        castingDateLess: '',
        buildingInspection: '',
        concreteCasting: ''
    }), [])

    const filterForm = useForm({ defaultValues: filterDefaults })
    const statusChangeForm = useForm()

    const buildDemandsQuery = (data, page) => {
        const params = new URLSearchParams()
        if (data.status != null && data.status !== '' && Number(data.status) !== -1) {
            params.set('status', String(data.status))
        }
        if (data.castingDateGreater) {
            params.set('castingDateGreater', data.castingDateGreater)
        }
        if (data.castingDateLess) {
            params.set('castingDateLess', data.castingDateLess)
        }
        if (data.buildingInspection) {
            params.set('buildingInspection', data.buildingInspection)
        }
        if (data.concreteCasting) {
            params.set('concreteCasting', data.concreteCasting)
        }
        params.set('page', String(Math.max(0, Number(page) || 0)))
        params.append('sort', 'concreteCastingDate,asc')
        params.append('sort', 'concreteCastingTime,asc')
        return params.toString()
    }

    const applyDemandsResponse = (response) => {
        const raw = response.data?.content || []
        const content = [...raw].sort(compareDemandsByCastingSchedule)
        setRequests(response.data ? { ...response.data, content } : { content: [] })
        setExcelData(
            content.map((item) => ({
                "Ruhsat Sahibi": item.licenceHolder,
                "İl / İlçe": item.city + " / " + item.town,
                "Blok Kat Kot": item.elevation,
                "Miktar": item.cubicMeter,
                "Talep Tarihi": formatCastingDateTr(item.concreteCastingDate),
                "Saat": formatCastingTimeTr(item.concreteCastingTime),
                "Santral": item.concreteBatchPlant,
                "Yapı Denetim": item.buildingInspection,
                "Beton Sınıfı": item.concreteType.name,
                "YİBF": item.yibfcode,
                "Statü": item.status,
                "Numune": item?.receiver ? item?.receiver?.firstName + " " + item?.receiver?.lastName : ""
            }))
        )
    }

    const fetchDemands = (page, formOverride = null) => {
        const data = formOverride ?? filterForm.getValues()
        const qs = buildDemandsQuery(data, page)
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/demands?${qs}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log("fetchDemands", response)
                applyDemandsResponse(response)
            })
            .catch((error) => {
                console.error(error)
                setRequests([])
            })
    }

    const getFilteredRequests = (data) => {
        setInPageIndex(0)
        fetchDemands(0, data)
    }

    const changeStatus = (data) => {
        console.log(data)
        axios.put(`${process.env.REACT_APP_SERVICE_URL}/demands/status`, {
            demandId: data.demandId,
            status: data.status,
            vehicleInfo: data.vehicleInfo,
            employeeId: parseInt(data.employeeId)

        }, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log(response.data)
                swal("Statü güncellendi!", {
                    icon: "success",
                })
                closeStatusChangeModal()
            })
            .catch((error) => {
                console.error(error)
                swal("Statü güncellenemedi!", {
                    icon: "error",
                })
            })
    }

    const resetFilteredRequests = () => {
        const d = {
            status: -1,
            castingDateGreater: moment().format('YYYY-MM-DD'),
            castingDateLess: '',
            buildingInspection: '',
            concreteCasting: ''
        }
        filterForm.reset(d)
        setInPageIndex(0)
        fetchDemands(0, d)
    }

    const [requestDetailsModal, setRequestDetailsModal] = useState({
        isOpen: false,
        requestInfo: null
    })

    const openRequestDetailsModal = (request) => {
        setRequestDetailsModal({
            isOpen: true,
            requestInfo: request
        })
    }

    const closeRequestDetailsModal = () => {
        setRequestDetailsModal({
            isOpen: false,
            requestInfo: null
        })
    }

    const handleRequestDateTimeUpdated = () => {
        closeRequestDetailsModal()
        fetchDemands(Number(inPageIndex) || 0)
    }

    const [statusChangeModal, setStatusChangeModal] = useState({
        isOpen: false,
    })

    const openStatusChangeModal = (request) => {
        setStatusChangeModal({
            isOpen: true,
            request
        })
        statusChangeForm.setValue('status', request?.availableStatuses?.[0]?.code)
        statusChangeForm.setValue('demandId', request?.id)
    }

    const closeStatusChangeModal = () => {
        setStatusChangeModal({
            isOpen: false,
            availableStatuses: []
        })
    }


    const requestApprove = (demandId) => {
        swal({
            title: "Onaylamak istediğinize emin misiniz?",
            text: "Bu işlem geri alınamaz!",
            icon: "warning",
            buttons: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.put(`${process.env.REACT_APP_SERVICE_URL}/demands/approve`, {
                    demandId
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                    .then((response) => {
                        console.log("requestApprove", response.data)
                        swal("Talep onaylandı!", {
                            icon: "success",
                        })
                        fetchDemands(Number(inPageIndex) || 0)
                    })
                    .catch((error) => {
                        console.error(error)
                        swal("Talep onaylanamadı!", {
                            icon: "error",
                        })
                    })
            }
        })
    }

    const [requestEvents, setRequestEvents] = useState({
        isOpen: false,
        events: []
    })
    const openRequestEventsModal = (events) => {
        console.log("openRequestEventsModal", events)
        setRequestEvents({
            isOpen: true,
            events
        })
    }

    const closeRequestEventsModal = () => {
        setRequestEvents({
            isOpen: false,
            events: []
        })
        console.log("closeRequestEventsModal")
    }

    const getStatusList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/demands/status`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log(response.data)
                setStatusList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setStatusList([])
            })
    }

    const getPersonalList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/employees`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log("getPersonalList", response.data)
                setPersonalList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setPersonalList([])
            })

    }

    const getYapiDenetimList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company?companyType=1`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log("getYapiDenetimList", response.data)
                setYapiDenetimList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setYapiDenetimList([])
            })
    }

    const getBetonSantralList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company?companyType=2`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((response) => {
                console.log("getBetonSantralList", response.data)
                setBetonSantralList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setBetonSantralList([])
            })

    }

    const getVehicleList = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/vehicle`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log("getVehicleList", response.data)
                setVehicleList(response.data)
            })
            .catch((error) => {
                console.error(error)
                setVehicleList([])
            })
    }

    useEffect(() => {
        getStatusList()
        getYapiDenetimList()
        getBetonSantralList()
        getVehicleList()
    }, [])

    useEffect(() => {
        fetchDemands(inPageIndex)
    }, [inPageIndex])

    const totalPages = Math.max(1, Number(requests?.totalPages) || 1)
    const pageIdx = Math.min(Math.max(0, Number(inPageIndex) || 0), totalPages - 1)

    useEffect(() => {
        const tp = requests?.totalPages
        if (typeof tp === 'number' && tp > 0 && inPageIndex >= tp) {
            setInPageIndex(tp - 1)
        }
    }, [requests?.totalPages, inPageIndex])

    const goPage = (nextIndex) => {
        const p = Math.min(Math.max(0, nextIndex), totalPages - 1)
        if (p !== (Number(inPageIndex) || 0)) {
            setInPageIndex(p)
        }
    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Talepler</title>
                <meta name='description' content='Talepler' />
                <meta name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no' />
            </Helmet>
            <HeaderTitle title="Talepler" description="Varsayılan: bugünden itibaren döküm tarihleri; liste döküm günü ve saatine göre sıralanır (bugün, yarın, …). Tümünü görmek için başlangıç tarihini temizleyip Filtrele'ye basın." />
            <div className='row mb-3 align-items-center g-2'>
                <div className='col-12 col-xl'>
                    <div className='d-flex flex-wrap align-items-center gap-2'>
                        {
                            canCreateDemand(role) && (
                                <Link
                                    to='/requests/create'
                                    className='btn btn-dark btn-app'
                                    data-tooltip-id="requests-tooltip"
                                    data-tooltip-content="Yeni talep"
                                    aria-label="Yeni talep oluştur">
                                    <i className='bi bi-plus-lg'></i>
                                    <span>Yeni talep</span>
                                </Link>
                            )
                        }
                        <button
                            type="button"
                            onClick={() => fetchDemands(Number(inPageIndex) || 0)}
                            className='btn btn-outline-secondary btn-app btn-app--icon'
                            data-tooltip-id="requests-tooltip"
                            data-tooltip-content="Yenile"
                            aria-label="Listeyi yenile">
                            <i className='bi bi-arrow-clockwise'></i>
                        </button>
                        <button
                            type="button"
                            className='btn btn-outline-secondary btn-app btn-app--icon'
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasExample"
                            aria-controls="offcanvasExample"
                            data-tooltip-id="requests-tooltip"
                            data-tooltip-content="Filtreler"
                            aria-label="Filtreler">
                            <i className='bi bi-funnel'></i>
                        </button>

                        <ExcelExport excelData={excelData} fileName={`${moment().format("DDMMYYYY")}-Talepler`} />
                    </div>
                </div>
                <div className='col-12 col-xl-auto'>
                    <div className='d-flex flex-wrap align-items-center gap-2 justify-content-xl-end'>
                        <span className='text-muted small text-nowrap me-1'>
                            {typeof requests?.totalElements === 'number' && (
                                <span className='me-2'>{requests.totalElements} kayıt</span>
                            )}
                            <span className='fw-medium text-body'>{pageIdx + 1}</span>
                            <span> / {totalPages}</span>
                        </span>
                        <div className='d-flex align-items-center gap-1' role="group" aria-label="Sayfa seçimi">
                            <button
                                type="button"
                                className='btn btn-outline-secondary btn-app btn-app--icon'
                                disabled={pageIdx <= 0}
                                onClick={() => goPage(0)}
                                data-tooltip-id="requests-tooltip"
                                data-tooltip-content="İlk sayfa"
                                aria-label="İlk sayfa">
                                <i className='bi bi-chevron-bar-left'></i>
                            </button>
                            <button
                                type="button"
                                className='btn btn-outline-secondary btn-app btn-app--icon'
                                disabled={pageIdx <= 0}
                                onClick={() => goPage(pageIdx - 1)}
                                data-tooltip-id="requests-tooltip"
                                data-tooltip-content="Önceki sayfa"
                                aria-label="Önceki sayfa">
                                <i className='bi bi-chevron-left'></i>
                            </button>
                            <select
                                className='form-select form-select-app'
                                id='inPage'
                                aria-label="Sayfa numarası"
                                value={pageIdx}
                                onChange={(e) => goPage(Number(e.target.value))}>
                                {
                                    [...Array(totalPages).keys()].map((p) => (
                                        <option key={p} value={p}>{p + 1}</option>
                                    ))
                                }
                            </select>
                            <button
                                type="button"
                                className='btn btn-outline-secondary btn-app btn-app--icon'
                                disabled={pageIdx >= totalPages - 1}
                                onClick={() => goPage(pageIdx + 1)}
                                data-tooltip-id="requests-tooltip"
                                data-tooltip-content="Sonraki sayfa"
                                aria-label="Sonraki sayfa">
                                <i className='bi bi-chevron-right'></i>
                            </button>
                            <button
                                type="button"
                                className='btn btn-outline-secondary btn-app btn-app--icon'
                                disabled={pageIdx >= totalPages - 1}
                                onClick={() => goPage(totalPages - 1)}
                                data-tooltip-id="requests-tooltip"
                                data-tooltip-content="Son sayfa"
                                aria-label="Son sayfa">
                                <i className='bi bi-chevron-bar-right'></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div className='table-responsive'>
                        <table className='table table-hover table-bordered table-sm'>
                            <thead className='bg-body-secondary'>
                                <tr>
                                    <th scope='col'>İşlem</th>
                                    <th scope='col'>Ruhsat Sahibi</th>
                                    <th scope='col'>İl / İlçe</th>
                                    <th scope='col'>Blok Kat Kot</th>
                                    <th scope='col'>Miktar</th>
                                    <th scope='col'>Talep Tarihi</th>
                                    <th scope='col'>Saat</th>
                                    <th scope='col'>Santral</th>
                                    <th scope='col'>Yapı Denetim</th>
                                    <th scope='col'>Beton Sınıfı</th>
                                    <th scope='col'>YİBF</th>
                                    <th scope='col'>Statü</th>
                                    <th scope='col'>Numune</th>
                                </tr>
                            </thead>
                            <tbody className='bg-body-secondary'>
                                {
                                    requests?.content?.map((request, index) => (
                                        <tr key={request.id}>
                                            <th className='align-middle'>
                                                <div className='d-inline-flex flex-wrap align-items-center gap-1'>
                                                    {
                                                        request.vehicle != null ?
                                                            <Link
                                                                className='btn btn-outline-primary btn-app btn-app--icon'
                                                                state={request.vehicle}
                                                                to={`/map-tracker`}
                                                                data-tooltip-id="requests-tooltip"
                                                                data-tooltip-content="Araç takibi"
                                                                aria-label="Araç takibi">
                                                                <i className='bi bi-truck'></i>
                                                            </Link> : null

                                                    }
                                                    {
                                                        request.buildingInspectionApproved === false && (hasAnyRole(role, 'YAPI_DENETIM') || isAdmin(role)) ?
                                                            <button
                                                                type="button"
                                                                onClick={() => requestApprove(request.id)}
                                                                className='btn btn-outline-success btn-app btn-app--icon'
                                                                data-tooltip-id="requests-tooltip"
                                                                data-tooltip-content="Onayla"
                                                                aria-label="Onayla">
                                                                <i className='bi bi-check-lg'></i>
                                                            </button> : null
                                                    }

                                                    {
                                                        request.concreteApproved === false && (hasAnyRole(role, 'BETON_SANTRALI') || isAdmin(role)) ?
                                                            <button
                                                                type="button"
                                                                onClick={() => requestApprove(request.id)}
                                                                className='btn btn-outline-success btn-app btn-app--icon'
                                                                data-tooltip-id="requests-tooltip"
                                                                data-tooltip-content="Onayla"
                                                                aria-label="Onayla">
                                                                <i className='bi bi-check-lg'></i>
                                                            </button> : null
                                                    }
                                                    {
                                                        (canManageDemandWorkflow(role) || showRequestApproveButtonList.includes(request.status)) ?
                                                            <button
                                                                type="button"
                                                                data-tooltip-id="requests-tooltip"
                                                                data-tooltip-content="Tarih ve Saat Değiştir"
                                                                onClick={() => openRequestDetailsModal(request)}
                                                                className='btn btn-outline-secondary btn-app btn-app--icon'
                                                                aria-label="Tarih ve saat düzenle">
                                                                <i className='bi bi-pencil'></i>
                                                            </button> : null
                                                    }
                                                    {
                                                        canManageDemandWorkflow(role) &&
                                                        <button
                                                            type="button"
                                                            data-tooltip-id="requests-tooltip"
                                                            data-tooltip-content="Statü Güncelle"
                                                            className='btn btn-outline-warning btn-app btn-app--icon text-dark border-warning'
                                                            onClick={() => openStatusChangeModal(request)}
                                                            aria-label="Statü güncelle">
                                                            <i className='bi bi-arrow-repeat'></i>
                                                        </button>
                                                    }

                                                    <button
                                                        type="button"
                                                        data-tooltip-id="requests-tooltip"
                                                        data-tooltip-content="Hareketler"
                                                        onClick={() => openRequestEventsModal(request.events)}
                                                        className='btn btn-outline-secondary btn-app btn-app--icon'
                                                        aria-label="Hareketler">
                                                        <i className='bi bi-list-ul'></i>
                                                    </button>
                                                </div>
                                            </th>
                                            <td className='align-middle'>{request.licenceHolder}</td>
                                            <td className='align-middle'>{request.city} / {request.town}</td>
                                            <td className='align-middle'>{request.elevation}</td>
                                            <td className='align-middle'>{request.cubicMeter}</td>
                                            <td className='align-middle'>{formatCastingDateTr(request.concreteCastingDate)}</td>
                                            <td className='align-middle'>{formatCastingTimeTr(request.concreteCastingTime)}</td>
                                            <td className='align-middle'>{request.concreteBatchPlant}</td>
                                            <td className='align-middle'>{request.buildingInspection}</td>
                                            <td className='align-middle'>{request.concreteType.name}</td>
                                            <td className='align-middle'>{request.yibfcode}</td>
                                            <td className='align-middle text-center'>
                                                {
                                                    request.status == "ONAYLANDI" ?
                                                        <i className='bi bi-check-circle-fill text-success'></i> :
                                                        request.status
                                                }
                                            </td>
                                            <td>
                                                {
                                                    request?.receiver &&
                                                    request?.receiver?.firstName + " " + request?.receiver?.lastName
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal isOpen={requestDetailsModal.isOpen} onRequestClose={closeRequestDetailsModal} headerTitle="Talep Detayları">
                <DetailsRequest request={requestDetailsModal.requestInfo} onUpdated={handleRequestDateTimeUpdated} />
            </Modal>

            <Modal isOpen={requestEvents.isOpen} onRequestClose={closeRequestEventsModal} headerTitle="Talep Hareketleri" >
                <div className='table-responsive'>
                    <table className='table table-hover table-bordered'>
                        <thead>
                            <tr>
                                <th>Tarih</th>
                                <th>Statü</th>
                                <th>Mesaj</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                requestEvents?.events?.map((event, index) => (
                                    <tr key={index}>
                                        <td>
                                            {
                                                moment(event?.date).format('DD.MM.YYYY HH:mm:ss')
                                            }
                                        </td>
                                        <td>{event?.status}</td>
                                        <td>{event?.eventMessage}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </Modal>

            <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel">Filtreler</h5>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-app btn-app--icon"
                        data-bs-dismiss="offcanvas"
                        aria-label="Kapat"
                        data-tooltip-id="requests-tooltip"
                        data-tooltip-content="Kapat">
                        <i className="bi bi-x-lg" aria-hidden="true"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <form onSubmit={filterForm.handleSubmit(getFilteredRequests)}>
                        <div className='mb-3'>
                            <label htmlFor='status' className='form-label'>Statü</label>
                            <select className='form-select' id='status' name="status" {...filterForm.register("status")}>
                                <option value={-1}>Tümü</option>
                                {
                                    statusList?.map((status, index) => (
                                        <option key={index} value={status.code}>{status.name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className='mb-3'>
                            <label htmlFor='createdDate' className='form-label'>Başlangıç Tarihi</label>
                            <input type='date' className='form-control' id='castingDateGreater' name="castingDateGreater" {...filterForm.register("castingDateGreater")} />
                        </div>

                        <div className='mb-3'>
                            <label htmlFor='endDate' className='form-label'>Bitiş Tarihi</label>
                            <input type='date' className='form-control' id='castingDateLess' name='castingDateLess' {...filterForm.register("castingDateLess")} />
                        </div>

                        <div className='mb-3'>
                            <label className='form-label'>Yapı Denetim</label>
                            <select className='form-select' {...filterForm.register("buildingInspection")}>
                                <option value="">Tümü</option>
                                {
                                    yapiDenetimList?.map((yapiDenetim, index) => (
                                        <option key={index} value={yapiDenetim.id}>{yapiDenetim.name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className='mb-3'>
                            <label className='form-label'>Beton Santral</label>
                            <select className='form-select' {...filterForm.register("concreteCasting")}>
                                <option value="">Tümü</option>
                                {
                                    betonSantralList?.map((betonSantral, index) => (
                                        <option key={index} value={betonSantral.id}>{betonSantral.name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className='mb-3'>
                            <div className='d-flex flex-wrap gap-2'>
                                <button
                                    type='submit'
                                    className='btn btn-dark btn-app btn-app--lg'
                                    data-tooltip-id="requests-tooltip"
                                    data-tooltip-content="Filtrele"
                                    aria-label="Filtreleri uygula">Filtrele</button>
                                <button
                                    type='button'
                                    onClick={resetFilteredRequests}
                                    className='btn btn-outline-secondary btn-app btn-app--lg'
                                    data-tooltip-id="requests-tooltip"
                                    data-tooltip-content="Filtreleri sıfırla"
                                    aria-label="Filtreleri sıfırla">Sıfırla</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div >

            <Modal isOpen={statusChangeModal.isOpen} onRequestClose={closeStatusChangeModal} headerTitle="Statü Güncelle" onAfterOpen={getPersonalList}>
                <form onSubmit={statusChangeForm.handleSubmit(changeStatus)}>
                    <div className='mb-3'>
                        <label htmlFor='status' className='form-label'>Statü</label>
                        <select
                            className='form-select'
                            onChange={(e) => {
                                statusChangeForm.setValue('status', e.target.value)
                            }}
                            value={statusChangeForm.watch('status')}
                        >
                            {
                                statusChangeModal?.request?.availableStatuses?.map((status, index) => (
                                    <option key={index} value={status.code}>{status.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    {
                        statusChangeForm.watch('status') == 1 &&
                        <>
                            <div className='mb-3'>
                                <label htmlFor='vehiclePlate' className='form-label'>Araç Plakası</label>
                                <select className='form-select' defaultValue={0} {...statusChangeForm.register('vehicleInfo', {
                                    validate: value => value != 0 || "Araç seçiniz"
                                })}>
                                    <option value="0">Seçiniz</option>
                                    {
                                        vehicleList?.map((vehicle) => (
                                            <option key={vehicle.id} value={vehicle.plate}>{vehicle.plate}</option>
                                        ))
                                    }
                                </select>
                                {
                                    statusChangeForm?.formState?.errors?.vehicleInfo && <div className="text-danger">
                                        {statusChangeForm?.formState?.errors?.vehicleInfo?.message}
                                    </div>
                                }
                            </div>
                            <div className='mb-3'>
                                <label className='form-label'>Personel</label>
                                <select className='form-select' defaultValue="0" {...statusChangeForm.register('employeeId', {
                                    validate: value => value != 0 || "Personel seçiniz"
                                })}>
                                    <option value="0">Seçiniz</option>
                                    {
                                        personalList?.map((personal, index) => (
                                            <option key={index} value={personal.id}>{personal.firstName}</option>
                                        ))
                                    }
                                </select>
                                {
                                    statusChangeForm?.formState?.errors?.employeeId && <div className="text-danger">
                                        {statusChangeForm?.formState?.errors?.employeeId?.message}
                                    </div>
                                }
                            </div>
                        </>
                    }
                    <div className='mb-3'>
                        <button
                            type="submit"
                            className='btn btn-dark btn-app btn-app--lg'
                            data-tooltip-id="requests-tooltip"
                            data-tooltip-content="Statü güncellemesini kaydet"
                            aria-label="Statü güncellemesini kaydet">Kaydet</button>
                    </div>
                </form>
            </Modal>

            <Tooltip id="requests-tooltip" place="top" />

        </div >
    )
}

export default Requests